import React, { FC } from 'react';
import { Customer, Lead, Product, MinimalUser } from '../..';
import { LeadContent } from './LeadContent';

export interface AdditionalLeadListContentProps {
  lead: Lead;
  users: MinimalUser[];
  customers: Customer[];
  products: Product[];
  isLeadDetails?: boolean;
}

export const AdditionalLeadListContent: FC<AdditionalLeadListContentProps> = (props) => {
  const { lead, users, customers, products, isLeadDetails = true } = props;
  return (
    <LeadContent lead={lead} users={users} customers={customers} products={products} isLeadDetails={isLeadDetails} />);
};
